import { Component } from '@angular/core';
import { App, IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the ChangepassPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-changepass',
	templateUrl: 'changepass.html',
})
export class ChangepassPage {

  	loginId: string;
  	api_key: string;
    version: string;
	password: string;
	new_password: string;
	new_password_confirm: string;

	public texts: any = [];
    public language : string;

	constructor(
		public app: App,
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		public toastCtrl: ToastController,
		public alertCtrl: AlertController
	) {
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "changepass");

		this.language = localStorage.getItem("language");
		this.version = localStorage.getItem("version");

        this._get_texts();
		
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).changepass;
	} 

	_change() {
		if (!this.password || this.password.length == 0) {
			const toast = this.toastCtrl.create({
				message: this.texts.toastM_password,
				duration: 2000,
				position: 'middle'
			});
			toast.present();
			return ;
		}
		if (!this.new_password || this.new_password.length == 0) {
			const toast = this.toastCtrl.create({
				message: this.texts.toastM_new_password,
				duration: 2000,
				position: 'middle'
			});
			toast.present();
			return ;
		}
		if (this.new_password != this.new_password_confirm) {
			const toast = this.toastCtrl.create({
				message: this.texts.toastM_confirm_password,
				duration: 2000,
				position: 'middle'
			});
			toast.present();
			return ;
		}

		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language, 
            version: this.version, 
			password: this.password, 
			new_password: this.new_password 
		});

		this.http.post("user/password", body).then((res:any) => {
			if(res.result == "OK") {
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.app.getRootNav().setRoot(LoginPage);

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			}else{
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		}, (err) => {
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		});
	}

	_close() {
		this.navCtrl.pop();
	}
}



// WEBPACK FOOTER //
// ./src/pages/changepass/changepass.ts